"use client";
import { login } from "@/auth/loginAction";
import Form from "@/components/ui/forms/tailwind/Form";
import Input from "@/components/ui/forms/tailwind/Input";
import PasswordInput from "@/components/ui/forms/tailwind/PasswordInput";
import RootError from "@/components/ui/forms/tailwind/RootError";
import SubmitButton from "@/components/ui/forms/tailwind/SubmitButton";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter, useSearchParams } from "next/navigation";
import { useForm } from "react-hook-form";
import { z } from "zod";

export default function LoginForm() {
  const schema = z.object({
    username: z.string().min(1, "Dato requerido"),
    password: z.string().min(1, "Dato requerido"),
  });

  const searchParams = useSearchParams();
  const router = useRouter();

  const form = useForm<z.infer<typeof schema>>({
    defaultValues: {
      username: "",
      password: "",
    },
    resolver: zodResolver(schema),
  });

  async function handleLogin(data: z.infer<typeof schema>) {
    try {
      const response = await login({
        ...data,
      });

      if (response.success === true) {
        router.push(searchParams.get("next") || "/admin");
      }

      // If we reach here, login failed (redirect would have happened on success)
      if (response.success === false) {
        form.setError("root", {
          message: "Usuario o contraseña incorrectos",
        });
      }
    } catch (error) {
      form.setError("root.serverError", {
        message:
          "Ha ocurrido un error al intentar iniciar sesión. Por favor, intenta nuevamente.",
      });
    }
  }

  return (
    <>
      <h2 className="wrap-balance my-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
        Ingresa al administrador
      </h2>
      <Form methods={form} onSubmit={handleLogin} className="space-y-6">
        <RootError formState={form.formState} />

        <Input
          name="username"
          autoComplete="username"
          label="Usuario"
          autoCapitalize="off"
          autoCorrect="off"
        />

        <PasswordInput
          name="password"
          label="Contraseña"
          autoComplete="current-password"
        />

        <div className="text-right text-sm leading-4">
          <a href="/admin/recuperar-clave" className="link">
            ¿Olvidaste tu contraseña?
          </a>
        </div>
        <div className="text-right text-sm leading-4">
          <a href="/personal" className="link">
            Ingresar con mi cuenta personal
          </a>
        </div>

        <SubmitButton fullWidth isPending={form.formState.isSubmitting}>
          Ingresar
        </SubmitButton>
      </Form>
    </>
    //   </div>

    //   <div className="hidden p-4 text-center sm:block ">
    //     <p className="mt-10 text-center text-sm text-white">
    //       ¿Necesitas una cuenta?{" "}
    //       <a
    //         href="#"
    //         className="font-semibold leading-6 text-white hover:text-white"
    //       >
    //         Comunicate con nosotros
    //       </a>
    //     </p>
    //     <Image
    //       src={wosm_logo}
    //       alt="World Organization of the Scout Movement"
    //       className="m-auto my-6 h-auto w-32"
    //     />
    //   </div>
    // </div>
  );
}
